import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  getSubscriptionPlanLink: async () =>
    apiCall(`${config.baseAPIUrl}/account/subscription`, {
      method: 'POST',
    }),
}
